// Utils & misc
import cn from '../../../utils/cn';

// Components
import DateTimeField from '../Fields/DateTimeField/DateTimeField';

// Styles
import styles from './TimeRangePicker.module.css';

/**
 * TimeRangePicker component - Time range picker for selecting start and end times
 * @param {object} props
 * @param {string} props.startTime - Start time value (HH:mm format)
 * @param {string} props.endTime - End time value (HH:mm format)
 * @param {(value: string) => void} props.onStartTimeChange - Handler for start time change
 * @param {(value: string) => void} props.onEndTimeChange - Handler for end time change
 * @param {string} [props.title] - Title to display in the popover
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} TimeRangePicker component
 */
function TimeRangePicker({
  startTime,
  endTime,
  onStartTimeChange,
  onEndTimeChange,
  title,
  className,
}) {
  return (
    <div className={cn([styles['time-range-picker'], className])}>
      {title && (
        <h3 className={styles.title}>{title}</h3>
      )}
      <div className={styles['time-inputs-group']}>
        <DateTimeField
          type="time"
          value={startTime}
          onChange={onStartTimeChange}
          name="start-time"
        />
        <span className={styles.separator}>à</span>
        <DateTimeField
          type="time"
          value={endTime}
          onChange={onEndTimeChange}
          name="end-time"
        />
      </div>
    </div>
  );
}

export default TimeRangePicker;
